import { CartItemDisclosure, Choice, Customization, FlattenCustomization } from "../api-models/order-pd-response.model";
import { ProductType } from "../order.model";
import { InternetCartData } from "./internet/internet-cart.model";
import { VideoCartData } from "./video/video-cart.model";
import { VoiceCartData } from "./voice/voice-cart.model";
import { WirelessCartData, WirelessCartSelectedCustomization } from "./wireless/wireless-cart.model";

export interface OrderCartData {
    internetCharges?: InternetCartData;
    wirelessCharges?: WirelessCartData;
    videoCharges?: VideoCartData;
    voiceCharges?: VoiceCartData;
    firstBillCharges?: CartCharges;
    todaysCharges?: CartCharges;
    packagesCharges?: CartCharges;
    savingAndPromotionCharges?: CartCharges;
    monthlyTotal?: number;
    totalAmount?: number;
}

export interface CartCharges {
    totalAmount?: number;
    items?: CartItem[];
    totalTaxAmount?: string;
}

export interface CartItem {
    choiceCode?: string;
    name?: string;
    amount?: number;
    disclosure?: string;
    seq?: number;
    type?: CartItemType;
    choice?: Choice;
    customization?: Customization;
    cartSectionType?: CartSectionType;
    metadata: WirelessCartSelectedCustomization | CartSelectedCustomization;
    isRequired?: boolean;
    productType?: ProductType;
    excludeFromProductSummary?: boolean; // If true, hide this item from summary page but keep in cart
    CartDisclosureList?: CartItemDisclosure[];
    showIncludedLabel?: boolean;
}

export enum CartItemType {
    Promotion = 'Promotion',
    Fee = 'Fee',
}

export enum CartSectionType {
    FirstBill = 'FirstBill',
    TodaysCharges = 'TodaysCharges',
    Packages = 'Packages',
    SavingsAndPromotions = 'SavingsAndPromotions',
    Monthly = 'Monthly',
    Device = 'Device',
    DeliveryAndHandling = 'DeliveryAndHandling'
}

export interface CartSelectedCustomization {
    Customization: Customization;
    Choice: Choice;
    customizationReference?: FlattenCustomization;
}